export default args => args.some(arg => arg);
